<template>
	<div class="commonModalBlo">
		<div class="commonModal modal textAlignC color_3435 overflowH">
			<div class="msg">
				{{text}}
			</div>
			<div class="buttonBlo buttonBloP">
				<el-button @click="submitHandle()" type="primary" :loading="loading">
					{{getSureText('确定', true)}}
				</el-button>

				<el-button @click="cancel()">{{getCancelText()}}</el-button>

				<!-- 20260302 注释原按钮逻辑 -->
				<!-- <div class="left" @click="submitHandle()">{{getSureText('确定', true)}}</div>
				<div class="rig" @click="cancel()">{{getCancelText()}}</div> -->
			</div>
		</div>
	</div>
</template>

<script setup>
	import useUserStore from '@/store/modules/user.js'
	import {
		getSureText,
		getCancelText
	} from '@/utils/common.js'

	const {
		proxy
	} = getCurrentInstance()
	const props = defineProps({
		text: {
			type: String,
			default: ''
		},
		loadingReset: {
			type: Boolean,
			default: false
		}
	})

	// 配置数据
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})

	const loading = ref(false)

	watch(() => props.loadingReset, val => {
		if (val) {
			loading.value = false
		}

		// console.log(val, loading.value, 'val loadingReset watch')
	}, {
		deep: true,
		immediate: true
	})

	// 点击回车键
	function keyDown(e) {
		let shortcutModelArr = userConfigData.value.shortcutModelArr
		console.log(e, 'e keyDown document.activeElement', document.activeElement)
		// enter键的ASCII是13
		if (e.keyCode === 13) {
			if (shortcutModelArr.includes(2)) {
				e.preventDefault();

				// 20260303 新增 重复提交禁用
				if (loading.value) {
					return
				}

				// 删除类弹窗 可直接禁用按钮
				loading.value = true

				submitHandle()
				e.stopPropagation();
			}
		} else if (e.keyCode === 27) {
			if (shortcutModelArr.includes(3)) {
				// Esc键的ASCII是27
				cancel()
			}
		}
	}

	function cancel() {
		proxy.$emit('cancelHandle')
	}

	function submitHandle() {
		proxy.$emit('sureHandle')
		// 二次确认类弹窗 可直接禁用按钮
		loading.value = true
	}

	onUnmounted(() => {
		useUserStore().isModal = false
		window.removeEventListener('keydown', keyDown, true)
	})

	onMounted(() => {
		// 当前是弹窗
		useUserStore().isModal = true
		// 绑定监听事件
		window.addEventListener('keydown', keyDown, true)
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";
	
	.commonModalBlo .modal {
		width: 296px;
		height: 160px;
		
		.buttonBlo.buttonBloP .el-button {
			min-width: unset !important;
			width: 80px !important;
		}
		
		.el-button + .el-button {
			margin-left: 0 !important;
		}
		
		.el-button--default {
			@include color('el-button--default_color');
			@include background('el-button--default_back');
			@include border('el-button--default_border');
		}
		
		.el-button--primary {
		  @include color('el-button--primary_color');
		  @include background('el-button--primary_back');
		  @include border('el-button--primary_border');
		}
	}
</style>